import { PageHero, Section, Seo, breadcrumb } from "@/components/site/Section";
import { POLICIES } from "@/data/policies";
import { openCookieSettings } from "@/lib/consent";

export default function Policy({ slug }) {
  const policy = POLICIES[slug];
  return (
    <>
      <Seo title={policy.title} description={`${policy.intro} WeeLogRun, Newtownabbey.`} path={`/${slug}`} jsonLd={breadcrumb(policy.title, `/${slug}`)} />
      <PageHero eyebrow="Legal" title={policy.title} intro={policy.intro} />
      <Section className="!pt-12">
        <div className="max-w-3xl">
          <p className="text-sm text-[#7a7a7a]">Last updated: 26 October 2026</p>
          <article className="lc-prose" data-testid={`policy-${slug}`}>
            {policy.sections.map((s) => (
              <section key={s.h}>
                <h2>{s.h}</h2>
                {s.p?.map((t) => <p key={t} className="mb-3">{t}</p>)}
                {s.l && <ul>{s.l.map((t) => <li key={t}>{t}</li>)}</ul>}
              </section>
            ))}
          </article>
          {slug === "cookie-policy" && (
            <button onClick={openCookieSettings} className="lc-btn-primary mt-10" data-testid="policy-cookie-settings">Open cookie settings</button>
          )}
        </div>
      </Section>
    </>
  );
}
